export let CommerceTool;
(function (CommerceTool) {
  CommerceTool["INVOICES"] = "invoices";
  CommerceTool["SUBSCRIPTIONS"] = "subscriptions";
  CommerceTool["PAYMENT_LINKS"] = "payment-links";
  CommerceTool["QUOTES"] = "quotes";
})(CommerceTool || (CommerceTool = {}));